@if (fleet) {
<nav class="container crumb-bar">
	<a class="crumb-item" [routerLink]="['../../../']">My {{brand.fleetPlural}}</a>
	<span class="crumb-item">&rsaquo;</span>
	<a class="crumb-item" [routerLink]="['../']">{{fleet?.fleet_name}}</a>
	<span class="crumb-item">&rsaquo;</span>
	<span class="crumb-item active">Usage Report</span>
</nav>
}

@if (!fleet) {
<div class="loading-status">
	<div class="logo-spin"></div>
	Loading fleet...
</div>
}

@if (fleet && assets === null) {
<div class="loading-status">
	No assets found in this fleet
</div>
}

@if (fleet && assets) {
<div class="container">
	<div class="section-title">Usage Report</div>
	<p>This will generate a report in XLSX format for the selected assets:</p>
	<div class="row mt-4">
		@for (asset of assets; track asset) {
		<div class="col-sm-4 col-lg-3">
			<label>
				<input type="checkbox" [(ngModel)]="asset.selected"> {{asset.asset_name}}
			</label>
		</div>
		}
	</div>
	<div>Select <a href="javascript:void(0);" (click)="SelectAll()">all</a> / <a href="javascript:void(0);" (click)="SelectNone()">none</a></div>
	<div class="mb-3 row my-4">
		<label class="col-md-2 align-content-sm-center">Start Date:</label>
		<div class="col-lg-3 col-md-4">
			<app-day-picker [(ngModel)]="startDate"></app-day-picker>
		</div>
		<label class="col-md-2 offset-lg-1 align-content-sm-center">End Date:</label>
		<div class="col-lg-3 col-md-4">
			<app-day-picker [(ngModel)]="endDate"></app-day-picker>
		</div>
	</div>
	<div class="mb-3 row my-4">
		<div class="col-md-4 mb-3">
			<label>
				<input type="checkbox" [(ngModel)]="includeOperations">
				Include operation list
			</label>
		</div>
		<div class="col-md-4 mb-3">
			<label>
				<input type="checkbox" [(ngModel)]="includeExceedances">
				Include exceedance list
			</label>
		</div>
		<div class="col-md-4 mb-3">
			<label>
				<input type="checkbox" [(ngModel)]="includeUserAccess">
				Include user access list
			</label>
		</div>
	</div>
	<div class="mb-3">
		<app-action-button [action]="GenerateReport" [context]="this" processing="Generating...">Generate Report</app-action-button>
	</div>
</div>
}